// extracted by mini-css-extract-plugin
export var container = "_6x-0";
export var fallback = "_6x-5";
export var fallbackIcon = "_6x-6";
export var hidden = "_6x-2";
export var image = "_6x-3";
export var loaded = "_6x-4";
export var placeholder = "_6x-1";